import React, { useState, useEffect, useContext } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Card,
  CardContent,
  Typography,
  IconButton,
  Tooltip,
  Box,
  Button,
  Popover,
} from "@mui/material";
import { shippingPriceService } from "../../utils/services/shippingPriceService";
import DeleteConfirmationModal from "../deleteConfirmationModal";
import AppContext from "../context/context";
import CustomTypography from "../../globalStyles/fonts";
import ShippingPriceDetailsModal from "../shipping-option-details-modal";
import { isMobile } from "../../globalStyles/mobile";
import { toast } from "react-toastify";
import CustomPagination from "../pagination";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "../../globalStyles/icons/editIcon";
import ViewIcon from "../../globalStyles/icons/vieewIcon";
import DeleteIcon from "../../globalStyles/icons/deleteIcon";
import { tableCellClasses } from "@mui/material/TableCell";
import SortingIcon from "../../globalStyles/icons/sorting-icon";
import { useTheme } from "@mui/styles";
import { styled } from "@mui/material/styles";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#EEEEEE",
    border: "1px solid #EAECF0",
    padding: "4px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "6px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#FFFFFF",
    border: "1px solid #EAECF0",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#F6F6F6",
    border: "1px solid #EAECF0",
  },
  "&:lastChild td, &:lastChild th": {
    border: 0,
  },
}));

const ShipmentOptionListView = ({
  viewMode,
  data,
  onEditData,
  onDeleteData,
  setPage,
  setRowsPerPage,
  rowsPerPage,
  page,
  dataCount,
  selectedShipmentPrice,
  setSelectedShipmentPrice,
}) => {
  const [deletingItemId, setDeletingItemId] = useState(null);
  const [shippigPriceData, setShippigPriceData] = useState([]);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const { user } = useContext(AppContext);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0 });
  const startIndex = page * rowsPerPage;
  const theme = useTheme();
  const defaultColor = "#D13438";
  const primary_color = theme.palette?.primary?.main || defaultColor;
  const [anchorElPopover, setAnchorElPopover] = useState(null);
  const openPopover = Boolean(anchorElPopover);

  const handleViewClick = (shipping) => {
    setOpenViewModal(true);
    handlePopoverClose();
  };

  const handleEditClick = (item) => {
    onEditData && onEditData(item);
    handlePopoverClose();
  };

  const handleDeleteClick = (item) => {
    setDeletingItemId(item._id);
    setOpenConfirmation(true);
    handlePopoverClose();
  };
  const handlePopoverOpen = (event, item) => {
    setSelectedShipmentPrice(item);
    event.stopPropagation();
    setAnchorElPopover(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorElPopover(null);
  };

  const deleteData = async () => {
    try {
      await shippingPriceService.delete(deletingItemId);
      setOpenConfirmation(false);
      onDeleteData && onDeleteData();
      toast.success("Shipment Options deleted successfully!");
    } catch (error) {
      toast.error("Failed to delete Shipment Options");
      console.error("Delete failed:", error);
    }
  };

  useEffect(() => {
    setShippigPriceData(
      data?.map((item) => ({
        ...item,
        action: (
          <Box sx={{ display: "flex", boxShadow: "none" }}>
            <IconButton
              aria-label="more actions"
              onClick={(e) => handlePopoverOpen(e, item)}
              sx={{
                color: openPopover ? "primary" : "inherit",
              }}
            >
              <MoreVertIcon />
            </IconButton>
            <Popover
              open={Boolean(anchorElPopover)}
              anchorEl={anchorElPopover}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                "& .MuiPaper-root": {
                  boxShadow: "none",
                  border: "1px solid #EAECF0",
                  borderRadius: "4px",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px",
                  boxShadow: "none",
                  gap: 1,
                }}
              >
                <Button
                  style={{
                    color: "#333333",
                    justifyContent: "flex-start",
                    textTransform: "none",
                  }}
                  onClick={() => handleViewClick(item)}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-start"
                    width="100%"
                    gap={1}
                  >
                    <ViewIcon />
                    <Typography
                      fontFamily={"poppins"}
                      fontSize={"16px"}
                      color={"#333333"}
                      fontWeight={500}
                    >
                      View
                    </Typography>
                  </Box>
                </Button>

                <Button
                  style={{
                    color: "#333333",
                    justifyContent: "flex-start",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    handleEditClick(selectedShipmentPrice);
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-start"
                    width="100%"
                    gap={1}
                  >
                    <EditIcon />
                    <Typography
                      fontFamily={"poppins"}
                      fontSize={"16px"}
                      color={"#333333"}
                      fontWeight={500}
                    >
                      Edit
                    </Typography>
                  </Box>
                </Button>
                <Button
                  style={{
                    color: "#333333",
                    justifyContent: "flex-start",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    handleDeleteClick(item);
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-start"
                    width="100%"
                    gap={1}
                  >
                    <DeleteIcon />
                    <Typography
                      fontFamily={"poppins"}
                      fontSize={"16px"}
                      color={"#333333"}
                      fontWeight={500}
                    >
                      Delete
                    </Typography>
                  </Box>
                </Button>
              </Box>
            </Popover>
          </Box>
        ),
      })),
    );
  }, [data, anchorElPopover]);

  const NoDataImage = () => (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <img
        src="no_data_rateCard.png"
        alt="No data available"
        style={{ objectFit: "fill", height: "300px" }}
      />
    </div>
  );

  const renderGridView = () => (
    <Grid
      sx={{
        marginTop: "1px",
        maxHeight: "100%",
        paddingBottom: 5,
        overflowY: "auto",
      }}
      container
      spacing={2}
    >
      {shippigPriceData?.map((x, index) => (
        <Grid sx={{ paddingBottom: 1 }} item xs={12} sm={6} md={4} key={index}>
          <Card
            sx={{
              boxShadow: 3,
              cursor: "pointer",
              width: "100%",
              height: "100%",
              position: "relative",
              borderRadius: "6px",
              border: "1px solid #D0D5DD",
            }}
          >
            <CardContent>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  fontWeight="500"
                  sx={{ textAlign: "start" }}
                  fontFamily="Poppins"
                  color="#333333"
                >
                  {startIndex + index + 1}
                </Typography>
                <div
                  style={{
                    position: "absolute",
                    top: 5,
                    right: 5,
                  }}
                >
                  {x?.action}
                </div>
              </div>
              <Grid container spacing={1} mt={2}>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="#333333"
                  >
                    Type
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Tooltip title={x?.type} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"#333333"}
                    >
                      : {x?.type}
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    Min Weight
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Tooltip title={x?.shipment_service?.type} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"#333333"}
                    >
                      :{" "}
                      {x?.pricing?.slice(0, 2).map((pricing, index) => (
                        <React.Fragment key={index}>
                          {pricing.min_weight}
                          {index === 0 && x?.pricing.length > 1 ? ", " : ""}
                        </React.Fragment>
                      ))}
                      {x?.pricing.length > 2 && (
                        <span
                          onClick={() => handleViewClick(x)}
                          style={{ cursor: "pointer", color: "#0073e6" }}
                        >
                          {` ... (${x?.pricing.length - 2} more)`}
                        </span>
                      )}
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    Max Weight
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Tooltip title={x.pricing.max_weight} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"#333333"}
                    >
                      :{" "}
                      {x?.pricing?.slice(0, 2).map((pricing, index) => (
                        <React.Fragment key={index}>
                          {pricing.max_weight}
                          {index === 0 && x?.pricing.length > 1 ? ", " : ""}
                        </React.Fragment>
                      ))}
                      {x?.pricing.length > 2 && (
                        <span
                          onClick={() => handleViewClick(x)}
                          style={{ cursor: "pointer", color: "#0073e6" }}
                        >
                          {` ... (${x?.pricing.length - 2} more)`}
                        </span>
                      )}
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    Min Days
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Tooltip title={x.pricing.max_weight} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"#333333"}
                    >
                      :
                      {x?.pricing?.slice(0, 2).map((pricing, index) => (
                        <React.Fragment key={index}>
                          {pricing.min_days}
                          {index === 0 && x?.pricing.length > 1 ? ", " : ""}
                        </React.Fragment>
                      ))}
                      {x?.pricing.length > 2 && (
                        <span
                          onClick={() => handleViewClick(x)}
                          style={{ cursor: "pointer", color: "#0073e6" }}
                        >
                          {` ... (${x?.pricing.length - 2} more)`}
                        </span>
                      )}
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    Max Days
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    :{" "}
                    {x?.pricing?.slice(0, 2).map((pricing, index) => (
                      <React.Fragment key={index}>
                        {pricing.max_days}
                        {index === 0 && x?.pricing.length > 1 ? ", " : ""}
                      </React.Fragment>
                    ))}
                    {x?.pricing.length > 2 && (
                      <span
                        onClick={() => handleViewClick(x)}
                        style={{ cursor: "pointer", color: "#0073e6" }}
                      >
                        {` ... (${x?.pricing.length - 2} more)`}
                      </span>
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    Price(USD)
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"#333333"}
                  >
                    :{" "}
                    {x?.pricing?.slice(0, 2).map((pricing, index) => (
                      <React.Fragment key={index}>
                        {pricing.price}
                        {index === 0 && x?.pricing.length > 1 ? ", " : ""}
                      </React.Fragment>
                    ))}
                    {x?.pricing.length > 2 && (
                      <span
                        onClick={() => handleViewClick(x)}
                        style={{ cursor: "pointer", color: "#0073e6" }}
                      >
                        {` ... (${x?.pricing.length - 2} more)`}
                      </span>
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  const renderListView = () => (
    <div
      style={{
        width: "100%",
        overflowY: isMobile() ? "auto" : "hidden",
        //paddingBottom: 100,
        maxHeight: "100%",
      }}
    >
      {isMobile() ? (
        renderGridView()
      ) : (
        <TableContainer
          sx={{
            overflowY: "auto",
            paddingInline: 0.4,
            maxHeight: "100%",
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              border: "1px solid var(--border-color)",
            }}
          >
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>
                  <Typography
                    fontSize="14px"
                    color="#333333"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    SL NO
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      //marginLeft: 20,
                    }}
                  >
                    {/* {filterData.columns.find((x) => x.key === "name")?.sort ===
                1 ? (
                  <Icon>
                    <UpIcon color="disabled" />
                  </Icon>
                ) : filterData.columns.find((x) => x.key === "name")
                    ?.sort === -1 ? (
                  <Icon>
                    <DownIcon color="disabled" />
                  </Icon>
                ) : null} */}
                    <Typography
                      fontSize="14px"
                      title={true}
                      color="#333333"
                      fontWeight={500}
                      fontFamily={"poppins"}
                    >
                      TYPE
                    </Typography>
                    <IconButton
                      aria-label="filter"
                      size="small"
                      //sonClick={(event) => handleOpenFilter(event, "name")}
                    >
                      <SortingIcon fill={primary_color} />
                    </IconButton>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    {/* {filterData.columns.find((x) => x.key === "email")?.sort ===
                1 ? (
                  <Icon>
                    <UpIcon color="disabled" />
                  </Icon>
                ) : filterData.columns.find((x) => x.key === "email")
                    ?.sort === -1 ? (
                  <Icon>
                    <DownIcon color="disabled" />
                  </Icon>
                ) : null} */}
                    <CustomTypography
                      fontSize="14px"
                      title={true}
                      color="#333333"
                      fontWeight={500}
                    >
                      {"MIN WEIGHT (kg)"}
                    </CustomTypography>
                    <IconButton
                      aria-label="filter"
                      size="small"
                      //   onClick={(event) => handleOpenFilter(event, "email")}
                    >
                      <SortingIcon fill={primary_color} />
                    </IconButton>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      //marginLeft: 20,
                    }}
                  >
                    {/* {filterData.columns.find((x) => x.key === "name")?.sort ===
                1 ? (
                  <Icon>
                    <UpIcon color="disabled" />
                  </Icon>
                ) : filterData.columns.find((x) => x.key === "name")
                    ?.sort === -1 ? (
                  <Icon>
                    <DownIcon color="disabled" />
                  </Icon>
                ) : null} */}
                    <Typography
                      fontSize="14px"
                      title={true}
                      color="#333333"
                      fontWeight={500}
                      fontFamily={"poppins"}
                    >
                      {" MAX WEIGHT (kg)"}
                    </Typography>
                    <IconButton
                      aria-label="filter"
                      size="small"
                      //sonClick={(event) => handleOpenFilter(event, "name")}
                    >
                      <SortingIcon fill={primary_color} />
                    </IconButton>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      //marginLeft: 20,
                    }}
                  >
                    {/* {filterData.columns.find((x) => x.key === "name")?.sort ===
                1 ? (
                  <Icon>
                    <UpIcon color="disabled" />
                  </Icon>
                ) : filterData.columns.find((x) => x.key === "name")
                    ?.sort === -1 ? (
                  <Icon>
                    <DownIcon color="disabled" />
                  </Icon>
                ) : null} */}
                    <Typography
                      fontSize="14px"
                      title={true}
                      color="#333333"
                      fontWeight={500}
                      fontFamily={"poppins"}
                    >
                      MIN DAYS
                    </Typography>
                    <IconButton
                      aria-label="filter"
                      size="small"
                      //sonClick={(event) => handleOpenFilter(event, "name")}
                    >
                      <SortingIcon fill={primary_color} />
                    </IconButton>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      //marginLeft: 20,
                    }}
                  >
                    {/* {filterData.columns.find((x) => x.key === "name")?.sort ===
                1 ? (
                  <Icon>
                    <UpIcon color="disabled" />
                  </Icon>
                ) : filterData.columns.find((x) => x.key === "name")
                    ?.sort === -1 ? (
                  <Icon>
                    <DownIcon color="disabled" />
                  </Icon>
                ) : null} */}
                    <Typography
                      fontSize="14px"
                      title={true}
                      color="#333333"
                      fontWeight={500}
                      fontFamily={"poppins"}
                    >
                      MAX DAYS
                    </Typography>
                    <IconButton
                      aria-label="filter"
                      size="small"
                      //sonClick={(event) => handleOpenFilter(event, "name")}
                    >
                      <SortingIcon fill={primary_color} />
                    </IconButton>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      //marginLeft: 20,
                    }}
                  >
                    <Typography
                      fontSize="14px"
                      title={true}
                      color="#333333"
                      fontWeight={500}
                      fontFamily={"poppins"}
                    >
                      {"PRICE (USD)"}
                    </Typography>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTypography
                    fontSize="14px"
                    title={true}
                    color="#333333"
                    fontWeight={500}
                  ></CustomTypography>
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {shippigPriceData?.map((x, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"Poppins"}
                    >
                      {startIndex + index + 1}
                    </Typography>
                  </StyledTableCell>
                  <Tooltip title={x?.type}>
                    <StyledTableCell>
                      <Typography
                        style={{
                          // marginLeft: 22,
                          maxWidth: 100,
                          whiteSpace: "nowrap", // Ensure single line
                          overflow: "hidden", // Prevent text overflow
                          textOverflow: "ellipsis", // Show ellipsis for overflow text
                        }}
                        fontSize="12px"
                        color="#667085"
                        fontWeight={400}
                        fontFamily={"Poppins"}
                        title={x?.type} // Add a title attribute to show full text on hover
                      >
                        {x?.type}
                      </Typography>
                    </StyledTableCell>
                  </Tooltip>

                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"poppins"}
                      //   sx={{
                      //     whiteSpace: "nowrap",
                      //     overflow: "hidden",
                      //     textOverflow: "ellipsis",
                      //     maxWidth: "200px",
                      //   }}
                      ml={0.5}
                    >
                      {x?.pricing?.slice(0, 2).map((pricing, index) => (
                        <React.Fragment key={index}>
                          {pricing.min_weight}
                          {index === 0 && x?.pricing.length > 1 ? ", " : ""}
                        </React.Fragment>
                      ))}
                      {x?.pricing.length > 2 && (
                        <span
                          onClick={() => handleViewClick(x)}
                          style={{ cursor: "pointer", color: "#0073e6" }}
                        >
                          {` ... (${x?.pricing.length - 2} more)`}
                        </span>
                      )}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"poppins"}
                      //   sx={{
                      //     whiteSpace: "nowrap",
                      //     overflow: "hidden",
                      //     textOverflow: "ellipsis",
                      //     maxWidth: "200px",
                      //   }}
                      ml={0.5}
                    >
                      {x?.pricing?.slice(0, 2).map((pricing, index) => (
                        <React.Fragment key={index}>
                          {pricing.max_weight}
                          {index === 0 && x?.pricing.length > 1 ? ", " : ""}
                        </React.Fragment>
                      ))}
                      {x?.pricing.length > 2 && (
                        <span
                          onClick={() => handleViewClick(x)}
                          style={{ cursor: "pointer", color: "#0073e6" }}
                        >
                          {` ... (${x?.pricing.length - 2} more)`}
                        </span>
                      )}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"poppins"}
                      //   sx={{
                      //     whiteSpace: "nowrap",
                      //     overflow: "hidden",
                      //     textOverflow: "ellipsis",
                      //     maxWidth: "200px",
                      //   }}
                      ml={0.5}
                    >
                      {x?.pricing?.slice(0, 2).map((pricing, index) => (
                        <React.Fragment key={index}>
                          {pricing.max_days}
                          {index === 0 && x?.pricing.length > 1 ? ", " : ""}
                        </React.Fragment>
                      ))}
                      {x?.pricing.length > 2 && (
                        <span
                          onClick={() => handleViewClick(x)}
                          style={{ cursor: "pointer", color: "#0073e6" }}
                        >
                          {` ... (${x?.pricing.length - 2} more)`}
                        </span>
                      )}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"poppins"}
                      //   sx={{
                      //     whiteSpace: "nowrap",
                      //     overflow: "hidden",
                      //     textOverflow: "ellipsis",
                      //     maxWidth: "200px",
                      //   }}
                      ml={0.5}
                    >
                      {x?.pricing?.slice(0, 2).map((pricing, index) => (
                        <React.Fragment key={index}>
                          {pricing.max_days}
                          {index === 0 && x?.pricing.length > 1 ? ", " : ""}
                        </React.Fragment>
                      ))}
                      {x?.pricing.length > 2 && (
                        <span
                          onClick={() => handleViewClick(x)}
                          style={{ cursor: "pointer", color: "#0073e6" }}
                        >
                          {` ... (${x?.pricing.length - 2} more)`}
                        </span>
                      )}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"poppins"}
                      //   sx={{
                      //     whiteSpace: "nowrap",
                      //     overflow: "hidden",
                      //     textOverflow: "ellipsis",
                      //     maxWidth: "200px",
                      //   }}
                      ml={0.5}
                    >
                      {x?.pricing?.slice(0, 2).map((pricing, index) => (
                        <React.Fragment key={index}>
                          {pricing.price}
                          {index === 0 && x?.pricing.length > 1 ? ", " : ""}
                        </React.Fragment>
                      ))}
                      {x?.pricing.length > 2 && (
                        <span
                          onClick={() => handleViewClick(x)}
                          style={{ cursor: "pointer", color: "#0073e6" }}
                        >
                          {` ... (${x?.pricing.length - 2} more)`}
                        </span>
                      )}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell sx={{ width: "3%", textAlign: "center" }}>
                    {x?.action}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );

  return (
    <>
      <div style={{ minWidth: "100%", minHeight: "100%" }}>
        <div
          style={{
            overflowY: "auto",
            display: "flex",
            maxHeight: `calc(100vh - 275px)`,
            width: "100%",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::WebkitScrollbar": { width: 0 },
          }}
        >
          {viewMode === "grid" ? renderGridView() : renderListView()}
        </div>

        <CustomPagination
          dataCount={dataCount}
          rowsPerPage={rowsPerPage}
          page={page}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          disableNext={dataCount <= rowsPerPage * (page + 1)}
        />
        <DeleteConfirmationModal
          DeleteConfirmationModal
          title={`Are you sure you want to delete ${selectedShipmentPrice?.type} ?`}
          open={openConfirmation}
          handleClose={() => setOpenConfirmation(false)}
          handleDelete={() => {
            deleteData();
          }}
        />
        <ShippingPriceDetailsModal
          shippingPrice={selectedShipmentPrice}
          open={openViewModal}
          onClose={() => setOpenViewModal(false)}
        />
      </div>
    </>
  );
};

export default ShipmentOptionListView;
